import type { EditorPlugin, EditorPluginCreator } from './../ricos-types';

import SpoilerEditorWrapper from './Components/Wrappers/SpoilerEditorWrapper';
import { DEFAULTS } from './defaults';
import { tiptapExtensions } from './tiptap/tiptap';
import type { SpoilerPluginEditorConfig } from './types';
import { SPOILER_TYPE } from './types';
export { SpoilerEditorWrapper };

import { getTextButtons } from './getTextButtons';
import { spoilerConverter } from './spoiler-converter';

export const pluginSpoiler: EditorPluginCreator<SpoilerPluginEditorConfig> = config => {
  const pluginConfig = { ...DEFAULTS.config, SpoilerEditorWrapper, ...config };
  return {
    config: pluginConfig,
    pmNodeConverters: [],
    pmMarkConverters: [spoilerConverter],
    type: SPOILER_TYPE,
    tiptapExtensions,
    textButtons: getTextButtons(),
  } as EditorPlugin;
};
